module.exports = __webpack_public_path__ + "static/media/mark-4-2000.5e74d430.jpg";